import React, { useState } from 'react';

export default function ContactForm() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  // Handler for input field changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const formData = new FormData(event.target);

    formData.append('access_key', '3c554148-0dbe-44d8-9dda-084e8acd2f0a');

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      setFormData({ name: '', email: '', subject: '', message: '' });
      setLoading(false);
    }
  };
  return (
    <form id='contact-form' onSubmit={onSubmit}>
      <div className='row gx-3 gy-4'>
        <div className='col-md-6'>
          <div className='form-group'>
            <label className='form-label'>Vote Nom complet</label>
            <input
              name='name'
              placeholder='Nom et Prénom *'
              className='form-control'
              type='text'
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className='col-md-6'>
          <div className='form-group'>
            <label className='form-label'>Votre Adresse Email</label>
            <input
              name='email'
              placeholder='Email *'
              className='form-control'
              type='email'
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className='col-12'>
          <div className='form-group'>
            <label className='form-label'>Objet de message</label>
            <input
              name='subject'
              placeholder='Objet *'
              className='form-control'
              type='text'
              value={formData.subject}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className='col-md-12'>
          <div className='form-group'>
            <label className='form-label'>
              Dites un peu sur votre idée/projet
            </label>
            <textarea
              name='message'
              placeholder='Votre message *'
              rows={4}
              className='form-control'
              value={formData.message}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <div className='col-md-12'>
          <div className='send'>
            <button
              className={`px-btn w-100 ${loading ? 'disabled' : ''}`}
              type='submit'
            >
              {loading ? 'Envoie en cours...' : 'Envoyer le Message'}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
